// Move Yotpo widget to reviews tab
document.addEventListener("DOMContentLoaded", function () {

  const importantNotesInput = document.querySelector(".ckb_important_notes input");
  const addToCartBtn = document.getElementById("product-add-to-cart");

  function getCheckboxValue() {
    if (importantNotesInput && importantNotesInput.checked) {
      addToCartBtn.disabled = false;
      console.log("Checkbox is checked!");
      return importantNotesInput.value;
    } 
  }

  // Small delay to allow DOM updates before checking the checkbox state
  setTimeout(() => {
    console.log("Checking checkbox on page load...");
    const checkboxValue = getCheckboxValue();
    console.log("Checkbox Value on Load:", checkboxValue);
  }, 300);

  const reviewsTab = document.getElementById("shopify-product-reviews");
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      const reviewWidget = document.getElementById("judgeme_product_reviews");
      
      if (reviewWidget && reviewsTab) {
        moveReviewsWidget(
          reviewWidget,
          reviewsTab
        );
      }
    });
  });

  function moveReviewsWidget(
    reviewWidget,
    reviewsTab
  ) {
    reviewsTab.appendChild(reviewWidget);
    observer.disconnect(); 
    
  }

  observer.observe(document.body, {
    childList: true, 
    subtree: true, 
  });

  const importantNotesLink = document.querySelector(".ckb_important_notes a");
  if (importantNotesLink) {
    importantNotesLink.addEventListener("click", function () {
      document.querySelectorAll(".tab a").forEach(function (tab) {
        tab.classList.remove("is-open");
      });
      document.querySelectorAll(".tab-content").forEach(function (tabContent) {
        tabContent.classList.remove("is-active");
      });
      document
        .querySelector(".custom_tab_important-notes")
        .classList.add("is-open");
      const tabImportantNotes = document.getElementById("tab-important-notes");
      if (tabImportantNotes) {
        tabImportantNotes.classList.add("is-active");
        tabImportantNotes.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  }



  if (importantNotesInput) {
    importantNotesInput.addEventListener("click", function () {
      if (this.checked) {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
        }
        document
          .querySelectorAll(".ckb_important_notes div")
          .forEach(function (div) {
            div.style.border = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p")
          .forEach(function (p) {
            p.style.textDecoration = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p a")
          .forEach(function (a) {
            a.style.textDecoration = "none";
          });
      } else {
        const addToCartBtn = document.getElementById("product-add-to-cart");
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
        }
      }
    });
  }

  const importantNotesCheckbox = document.querySelector(
    "input[name=pdp-important-notes-conf]"
  );
  if (importantNotesCheckbox) {
    importantNotesCheckbox.addEventListener("change", function () {
      if (!this.checked) {
        document
          .querySelectorAll(".ckb_important_notes div")
          .forEach(function (div) {
            div.style.border = "solid 2px red";
          });
        document
          .querySelectorAll(".ckb_important_notes p")
          .forEach(function (p) {
            p.style.textDecoration = "underline red";
          });
        document
          .querySelectorAll(".ckb_important_notes p a")
          .forEach(function (a) {
            a.style.textDecoration = "unset";
          });
      } else {
        // Remove previously applied red styles
        document
          .querySelectorAll(".ckb_important_notes div")
          .forEach(function (div) {
            div.style.border = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p")
          .forEach(function (p) {
            p.style.textDecoration = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p a")
          .forEach(function (a) {
            a.style.textDecoration = "none";
          });
      }
    });
  }

  const productFormButtons = document.querySelector(".product-form__buttons");
  if (productFormButtons) {
    productFormButtons.addEventListener("click", function () {
      const isChecked = document.querySelector(
        "input[data-gtm-form-interact-field-id]"
      )
        ? document.querySelector("input[data-gtm-form-interact-field-id]")
            .checked
        : 0;

      if (!isChecked) {
        document
          .querySelectorAll(".ckb_important_notes div")
          .forEach(function (div) {
            div.style.border = "solid 2px red";
          });
        document
          .querySelectorAll(".ckb_important_notes p")
          .forEach(function (p) {
            p.style.textDecoration = "underline red";
          });
        document
          .querySelectorAll(".ckb_important_notes p a")
          .forEach(function (a) {
            a.style.textDecoration = "unset";
          });
      } else {
        // Remove previously applied red styles
        document
          .querySelectorAll(".ckb_important_notes div")
          .forEach(function (div) {
            div.style.border = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p")
          .forEach(function (p) {
            p.style.textDecoration = "none";
          });
        document
          .querySelectorAll(".ckb_important_notes p a")
          .forEach(function (a) {
            a.style.textDecoration = "none";
          });
      }
    });
  }
});

class ShockTitlePdp {
  constructor(fitmentArg) {
    this.title = document.querySelector(".productView-title span").innerText;
    this.hasFitmentSelected = false;
    this.currentFitment = null;
    this.fitmentDataString = fitmentArg;
    this.fitmentDataArray =
      this.fitmentDataString !== ""
        ? stringToObject(this.fitmentDataString)
        : null;
    this.init();
  }

  init() {
    this.hasFitmentSelected = localStorage.getItem("fitmentData")
      ? true
      : false;
    this.currentFitment = this.hasFitmentSelected
      ? JSON.parse(localStorage.getItem("fitmentData")).currentVehicle
      : null;
    this.setTitle();
  }

  setTitle() {
    if (
      !this.title.toLowerCase().includes("kit") &&
      this.title.toLowerCase().includes("shock") &&
      this.hasFitmentSelected &&
      this.fitmentDataArray &&
      !isTitleFitted(this.title) &&
      this.currentFitment
    ) {
      const title = this.title;
      const fittedData = this.fitmentDataArray.filter((fitment) => {
        return isFitmentMatch(fitment, this.currentFitment);
      });
      const insertData = `(${fittedData[0].position} ${fittedData[0].lift_height}")`;
      const pipePos = this.title.indexOf("|");
      const result = `${title.slice(0, pipePos)} ${insertData} ${title.slice(
        pipePos
      )}`;
      document.querySelector(".productView-title span").innerText = result;
    }
  }
}

class ShockTitleCollections {
  constructor() {
    this.collectionProducts = [];
    this.collectionHandle = window.location.pathname.split("/")[2];
    this.hasFitmentSelected = false;
    this.currentFitment = null;
    this.init();
  }

  init() {
    this.hasFitmentSelected = localStorage.getItem("fitmentData")
      ? true
      : false;
    this.currentFitment = this.hasFitmentSelected
      ? JSON.parse(localStorage.getItem("fitmentData")).currentVehicle
      : null;
    if (this.hasFitmentSelected) this.processCollection();
    const targetNode = document.querySelector("#main-collection-product-grid");
    const config = { childList: true };

    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          this.processCollection();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  processCollection() {
    const collectionProducts = Array.from(
      document.querySelector("#main-collection-product-grid").children
    );
    if (collectionProducts.length === 0) {
      setTimeout(() => {
        this.processCollection();
      }, 200);
    } else {
      this.collectionProducts = collectionProducts;
      this.setTitles();
    }
  }

  setTitles() {
    this.collectionProducts.forEach(async (product) => {
      if (!product.querySelector(".product-item .card-title span")) return;
      const productTitle = product.querySelector(
        ".product-item .card-title span"
      )?.innerText;
      if (
        productTitle &&
        productTitle.toLowerCase().includes("shock") &&
        !productTitle.toLowerCase().includes("front") &&
        !productTitle.toLowerCase().includes("rear") &&
        this.currentFitment
      ) {
        const productJson = JSON.parse(
          product.querySelector("[data-json-product]").dataset.jsonProduct
        );
        const firstVariantSku = productJson.variants[0].sku;
        const fitmentDataString = await this.getProductFitmentData(
          firstVariantSku
        );
        if (!fitmentDataString) return;
        const fitmentDataArray = stringToObject(fitmentDataString);
        const fittedData = fitmentDataArray.filter((fitment) => {
          return isFitmentMatch(fitment, this.currentFitment);
        });
        const insertData = `(${fittedData[0].position} ${fittedData[0].lift_height}")`;
        const pipePos = productTitle.indexOf("|");
        const result = `${productTitle.slice(
          0,
          pipePos
        )} ${insertData} ${productTitle.slice(pipePos)}`;
        product.querySelector(".product-item .card-title span").innerText =
          result;
      }
    });
  }

  async getProductFitmentData(sku) {
    const query = `query {
        products(first: 1, query: "${sku}") {
          edges {
            node {
              productType  
              variants(first:1) {
                  edges {
                      node {
                          metafield(namespace:"pim", key:"fitment_details") {
                              value
                          }
                      }
                  }
              }
            }
          }
        }
      }`;

    const response = await makeGraphQLRequest(query);

    const productEdge = response.data.products.edges[0];
    const productType = productEdge.node.productType;
    const variantMetafield = productEdge.node.variants.edges[0]?.node.metafield;

    const fitmentData =
      productType === "Shocks & Coil-Overs" && variantMetafield
        ? variantMetafield.value
        : null;

    return fitmentData;
  }
}

// Helper functions
async function makeGraphQLRequest(query) {
  const response = await fetch(
    "https://bds-suspension.myshopify.com/api/2023-10/graphql.json",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "c79e6573ca3d58a17cfceb713f86fa0b",
      },
      body: JSON.stringify({ query }),
    }
  );
  const json = await response.json();
  return json;
}

function isTitleFitted(title) {
  return title.toLowerCase().includes("front") ||
    title.toLowerCase().includes("rear")
    ? true
    : false;
}

function isFitmentMatch(currentString, fitmentSelection) {
  if (!fitmentSelection) return false;
  const { year, make, model, submodel, drive_type, fuel_type } =
    fitmentSelection;

  let isFitmentMatch = false;

  const yearMatch = currentString.year === year;
  const makeMatch = currentString.make === make;
  const modelMatch = currentString.model === model;
  const submodelMatch =
    currentString.submodel === submodel || currentString.submodel === "X";

  // All fields should match (considering 'X' as wildcard for submodel)
  if (yearMatch && makeMatch && modelMatch && submodelMatch) {
    isFitmentMatch = true;
  }
  return isFitmentMatch;
}

function stringToObject(fitmentStrings) {
  const newStrArr = fitmentStrings.split(";");
  return newStrArr.map((str) => {
    const [
      year,
      make,
      model,
      submodel,
      drive_type,
      fuel_type,
      doors,
      type,
      position,
      lift_height,
      quantity,
    ] = str.split("|");
    return {
      year,
      make,
      model,
      submodel,
      drive_type,
      fuel_type,
      doors,
      type,
      position,
      lift_height,
      quantity,
    };
  });
}

new ShockTitleCollections();
